import { useCallback, useEffect, useState } from 'react';
import { apiCall } from '../_shared';

// Load/save one Booking.com-style settings document (plans / value_adds / child_rates) from our DB.
export const useSetting = (key) => {
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const load = useCallback(() => apiCall(`/api/admin/rates/settings/${key}`).then(setDoc).catch((e) => setErr(e.message)), [key]);
  useEffect(() => { load(); }, [load]);
  const save = async (data) => {
    setSaving(true); setErr('');
    try { const d = await apiCall(`/api/admin/rates/settings/${key}`, { method: 'PUT', body: JSON.stringify({ data }) }); setDoc(d); return true; } catch (e) { setErr(e.message); return false; } finally { setSaving(false); }
  };
  return { data: doc?.data, meta: doc, err, saving, save };
};

export const BOOKING_HOTEL_ID = process.env.REACT_APP_BOOKING_HOTEL_ID || '7759647';
export const extranetUrl = (page) => `https://admin.booking.com/hotel/hoteladmin/extranet_ng/manage/${page}.html?hotel_id=${BOOKING_HOTEL_ID}`;
